var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',[_c('fields-list',{attrs:{"item":_vm.item,"fields":_vm.fields}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }